import type { LandingData } from "../data/types"

export function Section5Atlas({ data }: { data: LandingData }) {
  return (
    <div className="copy-block method guarded-copy" data-motion="reveal">
      <p className="eyebrow mono">METHODOLOGY</p>
      <h2>Six inputs. One score.</h2>
      <div className="method-grid">
        {data.atlas_signal_inputs.map((input) => (
          <div key={input.id}>
            <b>{input.label}</b>
            <p>{input.blurb}</p>
          </div>
        ))}
      </div>
      <p className="fine mono">Each input is published. Each weight is fixed. The score is reproducible from the snapshot.</p>
    </div>
  )
}
